module.exports = __webpack_public_path__ + "static/media/long-arrow-down.8695ea3a.svg";